// Generated by CoffeeScript 2.7.0
var Ajax, AjaxRequest, DOMEval, _putOrPatch, accepts, default_ajax_options, generateUrlWithParams;

import UrlHelper from 'helpers/url_helper.js';

({generateUrlWithParams} = UrlHelper);

// options:
//   url: ''
//   async: true
//   data: null
//   method: 'GET'
//   timeout: 20000
//   beforeSend: (xhr, options)->
//   success: (data, xhr)->
//   error: (xhr, error)->
//   complete: (xhr)->
//   contentType: ''
//   responseType: 'json'
DOMEval = function(code) {
  var doc, script;
  doc = document;
  script = doc.createElement('script');
  script.text = code;
  doc.head.appendChild(script).parentNode.removeChild(script);
  return code;
};

default_ajax_options = {
  async: true,
  data: null,
  method: 'GET',
  contentType: 'application/x-www-form-urlencoded',
  timeout: 20000,
  responseType: 'json'
};

accepts = {
  "*": "*/".concat("*"),
  text: "text/plain",
  html: "text/html",
  xml: "application/xml, text/xml",
  document: "application/xml, text/xml",
  json: "application/json, text/javascript",
  script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
  plainscript: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
};

AjaxRequest = class AjaxRequest {
  constructor(url, options = {}) {
    var _onprogressFunc, csrf_token, data, execCompletes, execErrors, execSuccess, xhr;
    if (!_.isString(url)) {
      options = url;
      if (!options.url) {
        throw new Error('you hasnt Specified a url');
        return;
      }
      url = options.url;
    }
    this.options = _.extend({}, default_ajax_options, options);
    if (this.options.method.toUpperCase() === 'GET') {
      url = generateUrlWithParams(url, this.options.data);
    }
    this._success_callbacks = [];
    this._error_callbacks = [];
    this._complete_callbacks = [];
    this._progress_callbacks = [];
    if (typeof this.options.success === 'function') {
      this._success_callbacks.push(this.options.success);
    }
    if (typeof this.options.error === 'function') {
      this._error_callbacks.push(this.options.error);
    }
    if (typeof this.options.complete === 'function') {
      this._complete_callbacks.push(this.options.complete);
    }
    if (_.isFunction(this.options.progress)) {
      this._progress_callbacks.push(this.options.progress);
    }
    execSuccess = (req) => {
      var data;
      data = this._parseResponse(req);
      return _.each(this._success_callbacks, function(sf) {
        return sf(data, req);
      });
    };
    execErrors = (req, status) => {
      var data;
      data = this._parseResponse(req);
      return _.each(this._error_callbacks, function(ef) {
        return ef(req, status || req.statusText, data);
      });
    };
    execCompletes = (req) => {
      clearTimeout(this.timeoutTimer);
      return _.each(this._complete_callbacks, function(cf) {
        return cf(req);
      });
    };
    xhr = new XMLHttpRequest();
    this.xhr = xhr;
    this._execAbort = function(status) {
      xhr.abort();
      return execErrors(xhr, status);
    };
    _onprogressFunc = (e) => {
      var percentage;
      percentage = e.lengthComputable ? e.loaded / e.total : 0;
      return _.each(this._progress_callbacks, function(cb) {
        return cb(percentage);
      });
    };
    xhr.upload.onprogress = _onprogressFunc;
    xhr.onprogress = _onprogressFunc;
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) {
        return;
      }
      this._progress_callbacks = [];
      if (xhr.status === 0) {
        return;
      }
      if (xhr.status < 400) {
        execSuccess(xhr);
      } else {
        execErrors(xhr);
      }
      return execCompletes(xhr);
    };
    xhr.onerror = (e) => {
      this._progress_callbacks = [];
      execErrors(xhr);
      return execCompletes(xhr);
    };
    csrf_token = document.head.querySelector('meta[name=csrf-token]').content;
    // JSON.stringify bodies must use application/json; the legacy default
    // (x-www-form-urlencoded) leaves Rails unable to parse params (422).
    if (!(this.options.data instanceof FormData) && this.options.data != null && this.options.method.toUpperCase() !== 'GET') {
      if (this.options.contentType === 'application/x-www-form-urlencoded') {
        this.options.contentType = 'application/json';
      }
    }
    this.xhr.open(this.options.method.toUpperCase(), url, this.options.async);
    if (this.options.contentType) {
      this.xhr.setRequestHeader('Content-Type', this.options.contentType);
    }
    this.xhr.setRequestHeader('Accept', accepts[this.options.responseType] || accepts['*']);
    if (csrf_token) {
      this.xhr.setRequestHeader('X-CSRF-Token', csrf_token);
    }
    this.xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    if (this.options.beforeSend) {
      this.options.beforeSend(this.xhr, this.options);
    }
    data = options.data instanceof FormData ? options.data : JSON.stringify(this.options.data);
    this.xhr.send(data);
    this.timeoutTimer = setTimeout(() => {
      return this._execAbort('timeout');
    }, this.options.timeout);
  }

  done(fn) {
    this._success_callbacks.push(fn);
    return this;
  }

  fail(fn) {
    this._error_callbacks.push(fn);
    return this;
  }

  always(fn) {
    this._complete_callbacks.push(fn);
    return this;
  }

  progress(fn) {
    this._progress_callbacks.push(fn);
    return this;
  }

  success(fn) {
    return this.done(fn);
  }

  error(fn) {
    return this.fail(fn);
  }

  complete(fn) {
    return this.always(fn);
  }

  abort() {
    return this._execAbort('aborted');
  }

  _parseResponse(req) {
    var data, e;
    switch (this.options.responseType) {
      case 'json':
        try {
          data = JSON.parse(req.response);
          req.responseJSON = data;
          return data;
        } catch (error) {
          e = error;
          return req.response;
        }
        break;
      case 'document':
      case 'xml':
      case 'html':
        return req.responseXML;
      case 'script':
        return DOMEval(req.response);
      case 'plainscript':
        return req.response;
      default:
        return req.responseText;
    }
  }

};

Ajax = function(url, options = {}) {
  var method;
  if (!_.isString(url)) {
    options = url;
    if (!options.url) {
      throw new Error('you hasnt Specified a url');
      return;
    }
    url = options.url;
  }
  method = (options.method || 'GET').toLowerCase();
  return Ajax[method](url, options);
};

Ajax.get = function(url, options = {}) {
  return new AjaxRequest(url, _.extend(options, {
    method: 'GET'
  }));
};

Ajax.post = function(url, options = {}) {
  return new AjaxRequest(url, _.extend(options, {
    method: 'POST'
  }));
};

Ajax.delete = function(url, options = {}) {
  var oldBeforeSend;
  options.data = _.extend(options.data || {}, {
    _method: 'delete'
  });
  oldBeforeSend = options.beforeSend;
  options.beforeSend = function(xhr, options) {
    if (oldBeforeSend) {
      oldBeforeSend(xhr, options);
    }
    return xhr.setRequestHeader('X-Http-Method-Override', 'delete');
  };
  return new AjaxRequest(url, _.extend(options, {
    method: 'POST'
  }));
};

_putOrPatch = function(method, url, options) {
  var oldBeforeSend;
  if (options.data == null) {
    options.data = {};
  }
  if (options.data instanceof FormData) {
    options.data.append('_method', method);
  } else {
    options.data._method = method;
  }
  oldBeforeSend = options.beforeSend;
  options.beforeSend = function(xhr, options) {
    if (oldBeforeSend) {
      oldBeforeSend(xhr, options);
    }
    return xhr.setRequestHeader('X-Http-Method-Override', method);
  };
  return new AjaxRequest(url, _.extend(options, {
    method: 'POST'
  }));
};

Ajax.put = function(url, options = {}) {
  return _putOrPatch('put', url, options);
};

Ajax.patch = function(url, options = {}) {
  return _putOrPatch('patch', url, options);
};

Ajax.DOMEval = DOMEval;

export default Ajax;
